import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';
import { DateTime } from 'common/utils/date';

class StarRatingClass extends Component {
  render() {
    let options = {
      tooltips: {
        mode: 'nearest',
        footerMarginTop: 10,
        callbacks: {
          title: (tooltipItems, data) => {
            return `Week of ${DateTime.fromISO(tooltipItems[0].xLabel)
              .toLocaleString(DateTime.DATE_SHORT)}`;
          },
          labelColor: function (tooltipItem, chartInstance) {
            let datasetIndex = tooltipItem.datasetIndex;
            let color =
              chartInstance.data.datasets[datasetIndex].pointBackgroundColor;
            return { borderColor: 'transparent', backgroundColor: color };
          },
        },
      },
      scales: {
        xAxes: [
          {
            display: false,
          },
        ],
      },
    };

    return (
      <BaseChart
        type="line"
        id="starRatingOverTimeWithTeamAndCompany"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="created_at"
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default StarRatingClass;
